import StoolAnalysis from './StoolAnalysis';

export default StoolAnalysis;
